'use client';

import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const DropdownMenu = (props: {
  children: React.ReactNode;
  id?: string;
  isOpen: boolean;
  requiresTransparentBackground: boolean;
}) => {
  const { children, id = 'navbar-menu', isOpen } = props;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          id={id}
          className="mt-8 w-full max-w-[1480px] border-t border-black bg-white shadow min-[769px]:max-[1024px]:max-w-[98%]"
          initial={{ height: 0, opacity: 0, y: -20 }}
          animate={{ height: 'auto', opacity: 1, y: 0 }}
          exit={{ height: 0, opacity: 0, y: -20 }}
          transition={{ duration: 0.4, ease: 'easeInOut' }}
          style={{ overflow: 'hidden' }}
        >
          <motion.div
            className="w-full"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.1, duration: 0.3 }}
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DropdownMenu;
